// JavaScript Document
//components/configuration/standard/daysettings/DisplaySimulator.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';



const useStyles = makeStyles((theme) => ({
	display : {
        fontFamily: 'Digital',
		backgroundColor: 'black',
		padding: 1,
		//color : '#f80',
		textAlign: 'center',
		lineHeight: 0.9
	},
    digitsOn : {
        color : '#f80'
    },
    digitsOff : {
        color : 'black'
    },
    ds1 : {
        fontSize: '3rem'
    },
    ds2 : {
        fontSize: '5rem'
    },
    ds3 : {
        fontSize: '7rem',
    },
    ds4: {
        fontSize: '9rem'
    },
    ds5: {
        fontSize: '10rem'
    },
    ds6: {
        fontSize: '12rem'
    }

}));



export default function Digits(props) {
	const classes = useStyles();
  	const {text, scale, timing} = props;
	const [flashing, setFlashing] = React.useState(false);
	const [isOn, setIsOn] = React.useState(true);

    React.useEffect(() => {
        if(timing){
            setFlashing(true);
        } else {
            setFlashing(false);
        }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	React.useEffect(() => {
		if(flashing){
			setIsOn(false);
			setTimeout(() => setFlashing(false), timing.period * 1000);
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [flashing]);
	
	React.useEffect(() => {
		if(flashing){
			if(isOn){
				setTimeout(() => setIsOn(false), timing.on);
			} else {
				setTimeout(() => setIsOn(true), timing.off);
			}
		} else {
			setIsOn(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isOn]);

    return(
        <div className={classes.display}>
            <div className={isOn && text ? classes.digitsOn : classes.digitsOff}>
                <div className={classes['ds'+(scale || 2)]}>
                    {text || 'AS'}
                </div>
            </div>
        </div>
    );






    

}
